define(["exports", "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose", "react", "../../", "react-intl-universal", "styled-components", "../../themes", "../../utils"], function (_exports, _taggedTemplateLiteralLoose2, _react, _, _reactIntlUniversal, _styledComponents, _themes, _utils) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

  var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _taggedTemplateLiteralLoose2 = _interopRequireDefault(_taggedTemplateLiteralLoose2);
  _react = _interopRequireWildcard(_react);
  _reactIntlUniversal = _interopRequireDefault(_reactIntlUniversal);
  _styledComponents = _interopRequireDefault(_styledComponents);

  var _templateObject;

  var Form = _styledComponents.default.form.withConfig({
    displayName: "SearchProfessionals__Form",
    componentId: "sc-jbw2fl-0"
  })(["background:", ";padding:16px 0;div{min-width:calc(25% - 38px);}"], function (_ref) {
    var theme = _ref.theme;
    return theme.colors.white;
  });

  var ContainerFlex = (0, _styledComponents.default)(function (props) {
    return /*#__PURE__*/_react.default.createElement(_.Container, props);
  }).withConfig({
    displayName: "SearchProfessionals__ContainerFlex",
    componentId: "sc-jbw2fl-1"
  })(["display:flex;flex-direction:column;font-weight:", ";justify-content:space-between;> div{margin-bottom:16px;width:100%;}", ""], function (_ref2) {
    var theme = _ref2.theme;
    return theme.font.regular;
  }, _themes.device.desktop(_templateObject || (_templateObject = (0, _taggedTemplateLiteralLoose2.default)(["\n    flex-direction: row;\n\n    > div {\n      margin-bottom: 0;\n      margin-right: 16px;\n    }\n  "]))));

  var StyledButton = _styledComponents.default.button.withConfig({
    displayName: "SearchProfessionals__StyledButton",
    componentId: "sc-jbw2fl-2"
  })(["font-weight:bold;min-width:188px;"]);

  var SearchProfessionals = function SearchProfessionals(_ref3) {
    var fetchSuggestions = _ref3.fetchSuggestions,
        redirect = _ref3.redirect,
        i18n = _ref3.i18n,
        currentLocale = _ref3.currentLocale;

    var _useState = (0, _react.useState)([]),
        positions = _useState[0],
        setPositions = _useState[1];

    var _useState2 = (0, _react.useState)([]),
        locations = _useState2[0],
        setLocations = _useState2[1];

    var _useState3 = (0, _react.useState)([]),
        keywords = _useState3[0],
        setKeywords = _useState3[1];

    var _useState4 = (0, _react.useState)(true),
        isDisabled = _useState4[0],
        setIsDisabled = _useState4[1];

    var _useState5 = (0, _react.useState)(false),
        i18nLoaded = _useState5[0],
        setI18nLoaded = _useState5[1];

    (0, _react.useEffect)(function () {
      if (!i18nLoaded) {
        (0, _utils.initIntl)(i18n, currentLocale).then(function () {
          return setI18nLoaded(true);
        });
      }
    }, []); // Habilita/desabilita o botão para evitar busca vazia

    (0, _react.useEffect)(function () {
      setIsDisabled(!(positions.length || locations.length || keywords.length));
    }, [positions, locations, keywords]);
    return !i18nLoaded ? null : /*#__PURE__*/_react.default.createElement(_.BoxShadow, null, /*#__PURE__*/_react.default.createElement(Form, {
      onSubmit: function onSubmit(e) {
        e.preventDefault();
        redirect({
          keywords: keywords,
          positions: positions,
          locations: locations
        });
      }
    }, /*#__PURE__*/_react.default.createElement(ContainerFlex, null, /*#__PURE__*/_react.default.createElement(_.TagInput, {
      icon: {
        name: 'briefcase',
        type: 'solid'
      },
      placeholder: _reactIntlUniversal.default.get('BUSCA_PROFISSIONAIS.CARGOS'),
      name: "cargos",
      items: positions,
      handleAddition: function handleAddition(item) {
        return setPositions([].concat(positions, [item]));
      },
      onDelete: function onDelete(item) {
        return setPositions(positions.filter(function (v, i) {
          return i !== item;
        }));
      },
      activeOnBlur: true
    }), /*#__PURE__*/_react.default.createElement(_.TagInput, {
      icon: {
        name: 'map',
        type: 'solid'
      },
      placeholder: _reactIntlUniversal.default.get('BUSCA_PROFISSIONAIS.LOCALIZACAO'),
      name: "cidades",
      items: locations,
      fetchSuggestions: fetchSuggestions,
      handleAddition: function handleAddition(item) {
        return setLocations([].concat(locations, [item]));
      },
      onDelete: function onDelete(item) {
        return setLocations(locations.filter(function (v, i) {
          return i !== item;
        }));
      },
      onlyAcceptSuggestion: true
    }), /*#__PURE__*/_react.default.createElement(_.TagInput, {
      icon: {
        name: 'hash',
        type: 'solid'
      },
      placeholder: _reactIntlUniversal.default.get('BUSCA_PROFISSIONAIS.PALAVRA_CHAVE'),
      name: "palavra_chave",
      items: keywords,
      handleAddition: function handleAddition(item) {
        return setKeywords([].concat(keywords, [item]));
      },
      onDelete: function onDelete(item) {
        return setKeywords(keywords.filter(function (v, i) {
          return i !== item;
        }));
      },
      activeOnBlur: true
    }), /*#__PURE__*/_react.default.createElement(StyledButton, {
      as: _.Button,
      kind: "primary",
      scale: "small",
      disabled: isDisabled
    }, /*#__PURE__*/_react.default.createElement("span", null, _reactIntlUniversal.default.get('BUSCA_PROFISSIONAIS.BOTAO'))))));
  };

  var _default = SearchProfessionals;
  _exports.default = _default;
});